import React, {useState} from 'react';
import './App.css';

function App() {
  const [temperature, setTemperature] = useState(0);
  const [backgroundColor, setBackgroundColor] = useState('cold');

  const increaseTemperature = () => {

    let newTemperature = temperature + 1;
    setTemperature(newTemperature);
    if (newTemperature >= 65) {
      setBackgroundColor('hot');
    }
  };

  const decreaseTemperature = () => {

    let newTemperature = temperature - 1;
    setTemperature(newTemperature);

    if (newTemperature < 65) {
      setBackgroundColor('cold');
    }
  };

  return (
    <div className="App">
      <div className={`temperature ${backgroundColor}`}>
        <h2>{temperature}°F</h2>
      </div>
      <div className="button-container">
        <button onClick={increaseTemperature}>+</button>
        <button onClick={decreaseTemperature}>-</button>
      </div>
    </div>
  );
}

export default App;
